import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Container = styled.div`
    background:#fff;
    border:1px solid #2a848e7b;
    border-radius: 8px;
`;


export const PersonInfo = styled.div`
    padding:24px;
    display:flex;
    align-items: center;
`;


export const ImageContainer = styled.div`
    height:92px;
    width:92px;
    position: relative;

    > div, > img{
        box-shadow: 0 0 4px 2px rgba(0,0,0,0.10);
        overflow: hidden;
        border-radius: 50%;
    }
    ${mq(Devices.mobile)} {
        display:none;
    }
`;


export const PersonText = styled.div`
    display:flex;
    flex-direction: column;
    margin-left: 16px;
     span{
        :nth-of-type(1){
            font-size: 24px;
            font-weight: 500;
            line-height: 26px;
            
        }
        :nth-of-type(2){
            font-size: 18px;
            line-height: 20px;
            color:#5e5e5e;
        }
    }

    ${mq(Devices.mobile)} {
        display:none;
    }
`;


export const CoinBox = styled.div`
    background:#2a848e24;
    margin-left: auto;
    display:flex;
    gap:16px;
    border-radius: 12px;
    border:1px solid #2a848e4b;
    padding:16px;
    ${mq(Devices.mobile)} {
        width:100%;
    }
`;


export const IconBox = styled.div`
    background:#2a848e;
    border-radius: 8px;
    width:50px;
    height:50px;
    display:flex;
    align-items: center;
    justify-content: center;

    svg{
        width:32px;
        height:32px;
        path {
            stroke:#fff;
        }
    }
`;

export const CoinText = styled.div`
    display:flex;
    flex-direction: column;
    justify-content: space-between;

    span{
        :nth-of-type(1){
            font-size: 14px;
            line-height: 16px;
            color:#5e5e5e;
        }
        :nth-of-type(2){
            font-size: 24px;
            line-height: 26px;
            color:#2a848e;
            font-weight: 500;
        }
    }
`;

export const ManageCoins = styled.div`
    background:#f0f4f5;
    padding:24px;
    border-bottom: 1px solid #0000001a;
    border-top: 1px solid #0000001a;

    span{
        font-size: 14px;
        display:blocK;
        margin-top: 8px;
        font-weight: 500;
        margin-bottom: 4px;
    }

    input{
        width:100%;
        font-size: 14px;
        border:1px solid #2a848e4b;
        border-radius: 6px;
        padding:12px 16px;
        outline:none;
    }
`;

export const ManageTitle = styled.p`
    font-size: 18px;
    color:#5e5e5e;

`;

export const Buttons = styled.div`
    width:100%;
    margin-top: 16px;
    display:flex;
    gap:10px;

    button{
        width:100%;
        font-size: 14px;
        border-radius: 6px;
        padding:12px 16px;
        color:#fff;
        font-weight: 500;
        transition:all 0.2s ease-in-out;

        :nth-of-type(2){
            background:#2a848e;
        }
        :nth-of-type(1){
            background:#fa505e;
        }

        :hover{
            opacity: 0.8;
        }
    }
    button:disabled{
        background:#c4c4c4 !important;
    }
`;

export const TransactionLog = styled.div`
    padding:24px;

    table{
        width:100%;
        margin-top: 8px;
        font-size: 14px;

        th{
            font-weight: 500;
            text-align: left;
        }       

        th:nth-of-type(1){ width: 180px; }
        th:nth-of-type(2){ width: 120px; }
        th:nth-of-type(3){ width: 100px; }
        th:nth-of-type(4){ width: 250px; }
    }

    > div {
        max-height: 200px;
        overflow-y: auto;
    }
`;

export const LogTitle = styled.span`
    font-size: 18px;
    color:#5e5e5e;
    display:block;
`;

export const LogSubTitle = styled.span`
    font-size: 14px;
    color:#5e5e5e;
    display:block;
`;